import { payDetailList as payDetailList1 } from '../request1';
import { payDetailList } from '../request2';
export default {
  data() {
    return {
      infoShow: false,
      form: {},
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '订单号'
        },
        dataIndex: 'orderNo',
        key: 'orderNo',
        align: 'center'
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'customerInsuranceName',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'customerInsuranceName'
        }
      }, {
        slots: {
          title: '被保人姓名'
        },
        dataIndex: 'insuredName',
        key: 'insuredName',
        align: 'center',
        customRender: text => {
          return {
            children: text || '—'
          };
        }
      }, {
        slots: {
          title: '支付状态'
        },
        dataIndex: 'payStatusName',
        key: 'payStatusName',
        align: 'center',
        scopedSlots: {
          customRender: 'payStatusName'
        }
      }, {
        slots: {
          title: '订单金额'
        },
        dataIndex: 'totalFee',
        key: 'totalFee',
        align: 'center'
      }]
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = {
        orderNo: this.form.orderNo,
        payStatus: this.form.payStatus,
        pageSize: this.pagination.pageSize,
        page: this.pagination.current,
        customerId: this.$route.params.customerId,
        payInfoId: this.$route.params.payInfoId
      };
      let request = this.$store.state.user.accountInfo.customerId ? payDetailList : payDetailList1;
      request(obj).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    reset() {
      this.form = {};
    }
  }
};